import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Label from './Label';
import { ExclamationCircleIcon } from './Icons';
export default function Input(t0) {
  const $ = _c(63);
  let id;
  let label;
  let maxLength;
  let onChange;
  let props;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    ({
      label,
      id,
      type: t1,
      size: t2,
      required: t3,
      disabled: t4,
      error: t5,
      errorMessage: t6,
      placeholder: t7,
      maxLength,
      onChange,
      borderRadius: t8,
      className: t9,
      wrapperClassName: t10,
      labelClass: t11,
      labelProps: t12,
      name: t13,
      rows: t14,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = id;
    $[2] = label;
    $[3] = maxLength;
    $[4] = onChange;
    $[5] = props;
    $[6] = t1;
    $[7] = t10;
    $[8] = t11;
    $[9] = t12;
    $[10] = t13;
    $[11] = t14;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    id = $[1];
    label = $[2];
    maxLength = $[3];
    onChange = $[4];
    props = $[5];
    t1 = $[6];
    t10 = $[7];
    t11 = $[8];
    t12 = $[9];
    t13 = $[10];
    t14 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  const type = t1 === undefined ? "text" : t1;
  const size = t2 === undefined ? "medium" : t2;
  const required = t3 === undefined ? false : t3;
  const disabled = t4 === undefined ? false : t4;
  const error = t5 === undefined ? false : t5;
  const errorMessage = t6 === undefined ? "" : t6;
  const placeholder = t7 === undefined ? "" : t7;
  const borderRadius = t8 === undefined ? "8px" : t8;
  const className = t9 === undefined ? "" : t9;
  const wrapperClassName = t10 === undefined ? "" : t10;
  const labelClass = t11 === undefined ? "" : t11;
  let t15;
  if ($[20] !== t12) {
    t15 = t12 === undefined ? {} : t12;
    $[20] = t12;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const labelProps = t15;
  const name = t13 === undefined ? "" : t13;
  const rows = t14 === undefined ? 4 : t14;
  let t16;
  if ($[22] !== className || $[23] !== disabled || $[24] !== error || $[25] !== size) {
    const sizeClasses = {
      small: "text-sm px-2 py-1 font-medium",
      medium: "text-base px-3 py-2 font-medium",
      large: "text-lg px-4 py-3 font-medium"
    };
    t16 = clsx("block w-full rounded-md bg-white px-3 py-1.5 text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-1 focus:-outline-offset-1 focus:outline-[#00EAFD] text-base", sizeClasses[size], {
      "cursor-not-allowed !bg-[#f9f9f9] !text-[#999999]": disabled,
      "pr-10 outline-red-600 focus:outline-red-600": error
    }, className);
    $[22] = className;
    $[23] = disabled;
    $[24] = error;
    $[25] = size;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  const commonClasses = t16;
  let t17;
  if ($[27] !== wrapperClassName) {
    t17 = clsx("flex flex-col gap-1", wrapperClassName);
    $[27] = wrapperClassName;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const wrapperClasses = t17;
  let t18;
  if ($[29] !== id || $[30] !== label || $[31] !== labelClass || $[32] !== labelProps || $[33] !== required) {
    t18 = label && <Label htmlFor={id} required={required} className={labelClass} {...labelProps}>{label}</Label>;
    $[29] = id;
    $[30] = label;
    $[31] = labelClass;
    $[32] = labelProps;
    $[33] = required;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== borderRadius || $[36] !== commonClasses || $[37] !== disabled || $[38] !== id || $[39] !== maxLength || $[40] !== name || $[41] !== onChange || $[42] !== placeholder || $[43] !== props || $[44] !== required || $[45] !== rows || $[46] !== type) {
    t19 = type === "textarea" ? <textarea id={id} required={required} disabled={disabled} placeholder={placeholder} maxLength={maxLength} onChange={onChange} rows={rows} style={{
      borderRadius
    }} className={commonClasses} name={name} {...props} /> : <input id={id} type={type} required={required} disabled={disabled} placeholder={placeholder} maxLength={maxLength} onChange={onChange} style={{
      borderRadius
    }} className={commonClasses} name={name} {...props} />;
    $[35] = borderRadius;
    $[36] = commonClasses;
    $[37] = disabled;
    $[38] = id;
    $[39] = maxLength;
    $[40] = name;
    $[41] = onChange;
    $[42] = placeholder;
    $[43] = props;
    $[44] = required;
    $[45] = rows;
    $[46] = type;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== error || $[49] !== errorMessage || $[50] !== type) {
    t20 = error && errorMessage && type !== "textarea" && <ExclamationCircleIcon className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500 h-5 w-5" aria-hidden="true" />;
    $[48] = error;
    $[49] = errorMessage;
    $[50] = type;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t19 || $[53] !== t20) {
    t21 = <div className="relative w-full">{t19}{t20}</div>;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== error || $[56] !== errorMessage) {
    t22 = error && errorMessage && <span className="text-red-600 text-xs mt-1">{errorMessage}</span>;
    $[55] = error;
    $[56] = errorMessage;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== t18 || $[59] !== t21 || $[60] !== t22 || $[61] !== wrapperClasses) {
    t23 = <div className={wrapperClasses}>{t18}{t21}{t22}</div>;
    $[58] = t18;
    $[59] = t21;
    $[60] = t22;
    $[61] = wrapperClasses;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  return t23;
}
Input.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  borderRadius: PropTypes.string,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  labelProps: PropTypes.object,
  rows: PropTypes.number
};